
import { login, logout, getInfo, getUserInfoDetail } from '@/util/api'
import { getToken, setToken, removeToken } from '@/util/auth'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: localStorage.getItem('userInfo') ? [JSON.parse(localStorage.getItem('userInfo')).roleCode] : [],
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : { permissionCodes: [] },
  userMenuTree: [],
  fapiao: {},
  tabchoose: '0',
  choosefapiao: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USEINFO: (state, userInfo) => {
    state.userInfo = userInfo;
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  setUserTree: (state, userMenuTree) => {
    state.userMenuTree = userMenuTree
  },
  setFapiao: (state, fapiao) => {
    state.fapiao = fapiao
  },
  setTabChoose: (state, tabchoose) => {
    state.tabchoose = tabchoose
  },
  setChooseFapiao: (state, choose) => {
    state.choosefapiao = choose
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token);
        commit('SET_USEINFO', data.loginSysUserVo);
        commit('SET_ROLES', [data.roleCode])
        setToken(data.token)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  setUserInfo: ({ commit }, data) => {
    commit('SET_TOKEN', data.token);
    commit('SET_USEINFO', data.loginSysUserVo);
    setToken(data.token)
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfoDetail(state.userInfo.id).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { nickname, head } = data
        // const roles = [roleCode]
        // // roles must be a non-empty array
        // if (!roles || roles.length <= 0) {
        //   reject('getInfo: roles must be a non-null array!')
        // }

        // commit('SET_ROLES', roles)
        commit('SET_NAME', nickname)
        commit('SET_AVATAR', head)
        commit('SET_USEINFO', data);
        commit('SET_USEINFO', Object.assign({}, state.userInfo, data));
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken()
        window.location.reload();
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js